import { render } from "./CoachContact.vue?vue&type=template&id=752ee74e&scoped=true"
import script from "./CoachContact.vue?vue&type=script&lang=js"
export * from "./CoachContact.vue?vue&type=script&lang=js"

import "./CoachContact.vue?vue&type=style&index=0&id=752ee74e&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752ee74e"]])

export default __exports__